const devRoutes = {
  auth: {
    login: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/login/',
    loginbypass: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/loginbypass/',
    verify: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/verify/',
    setpass: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/setpass/',
  },
  report: 'http://mega.comfortkino.an/local/php_interface/api/v1/bug_report/',
  vacancy: 'http://mega.comfortkino.an/local/php_interface/api/v1/vacancy/',
  buy: {
    user: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/',
    // user: '/dist/static/user.json',
    session: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/',
    // session: '/dist/static/session.json',
    places: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/places/',
    // places: '/static/places.json',
    buy: 'http://mega.comfortkino.an/local/php_interface/api/v1/buy/add/',
    verify: 'http://mega.comfortkino.an/local/php_interface/api/v1/buy/verify/',
    geo: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/geo/',
    // geo: '/dist/static/geo.json',
    avatar: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/avatar/',
    cancel: 'http://mega.comfortkino.an/local/php_interface/api/v1/buy/cancel/',
    info: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/info/',
  },
  showScheme: {
    user: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/',
    session: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/order/',
    places: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/places/',
    buy: 'http://mega.comfortkino.an/local/php_interface/api/v1/buy/add/',
    verify: 'http://mega.comfortkino.an/local/php_interface/api/v1/buy/verify/',
    geo: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/geo/',
    avatar: 'http://mega.comfortkino.an/local/php_interface/api/v1/session/avatar/',
  },
  card: {
    user: '/static/user.json',
    activate: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/card/activate/',
  },
  playbill: {
    main: 'http://almaz.comfortkino.an/local/php_interface/api/v1/films/playbill/',
    wishlist: 'http://almaz.comfortkino.an/local/php_interface/api/v1/user/wishlist/',
    like: 'https://almaz.comfortkino.an/local/php_interface/api/v1/films/like/',
  },
  scheme_screen: '/dist/static/js/scheme-screen/testData/index.js',
  profile: {
    user: '/dist/static/user.json',
    edit: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/edit/',
    login: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/login/',
    verify: 'http://mega.comfortkino.an/local/php_interface/api/v1/user/verify/',
  },
};

const prodRoutes = {
  auth: {
    login: '/local/php_interface/api/v1/user/login/',
    loginbypass: '/local/php_interface/api/v1/user/loginbypass/',
    verify: '/local/php_interface/api/v1/user/verify/',
    setpass: '/local/php_interface/api/v1/user/setpass/',
  },
  report: '/local/php_interface/api/v1/bug_report/',
  vacancy: '/local/php_interface/api/v1/vacancy/',
  buy: {
    user: '/local/php_interface/api/v1/user/',
    session: '/local/php_interface/api/v1/session/',
    places: '/local/php_interface/api/v1/session/places/',
    buy: '/local/php_interface/api/v1/buy/add/',
    verify: '/local/php_interface/api/v1/buy/verify/',
    geo: '/local/php_interface/api/v1/user/geo/',
    avatar: '/local/php_interface/api/v1/session/avatar/',
    cancel: '/local/php_interface/api/v1/buy/cancel/',
    info: '/local/php_interface/api/v1/session/info/',
  },
  showScheme: {
    user: '/local/php_interface/api/v1/user/',
    session: '/local/php_interface/api/v1/session/order/',
    places: '/local/php_interface/api/v1/session/places/',
    buy: '/local/php_interface/api/v1/buy/add/',
    verify: '/local/php_interface/api/v1/buy/verify/',
    geo: '/local/php_interface/api/v1/user/geo/',
    avatar: '/local/php_interface/api/v1/session/avatar/',
  },
  card: {
    user: '/local/php_interface/api/v1/user/',
    activate: '/local/php_interface/api/v1/user/card/activate/',
  },
  playbill: {
    main: '/local/php_interface/api/v1/films/playbill/',
    wishlist: '/local/php_interface/api/v1/user/wishlist/',
    like: '/local/php_interface/api/v1/films/like/',
  },
  scheme_screen: '/local/php_interface/api/v1/promo',
  profile: {
    user: '/local/php_interface/api/v2/user/',
    edit: '/local/php_interface/api/v1/user/edit/',
    login: '/local/php_interface/api/v1/user/login/',
    verify: '/local/php_interface/api/v1/user/verify/',
  },
  unpaid: '/local/php_interface/api/v1/user/session',
};

const routes = process.env.NODE_ENV == 'dev' ? devRoutes : prodRoutes;

export default routes;
